export default __webpack_public_path__ + "static/media/tool_item_4_m.77004bc2.png";